import React from "react";

import { useIntl } from "react-intl";

import Price from "@mapmycustomers/shared/types/plans/Price";
import Tier from "@mapmycustomers/shared/types/plans/Tier";

import formatPrice from "../../util/formatPrice";
import { DescriptionColumn, PriceColumn, Row } from "../BaseRow";

interface Props {
  licenses: number;
  price: Price;
  selectedTier: Tier;
}

const TotalRow: React.FC<Props> = ({ licenses, price, selectedTier }) => {
  const intl = useIntl();
  return (
    <Row>
      <DescriptionColumn
        description={intl.formatMessage(
          {
            id: "billing.summary.total.description",
            defaultMessage: "{count} {count, plural, one {license} other {licenses}} × {price}",
            description: "Total summary row description on Billing page",
          },
          { count: licenses, price: formatPrice(intl, selectedTier.price) }
        )}
        title={intl.formatMessage(
          {
            id: "billing.summary.total.title",
            defaultMessage: "{interval, select, monthly {Monthly } annual {Annual } other {}}Total",
            description: "Total per subscription interval summary row on Billing page",
          },
          { interval: selectedTier.interval }
        )}
      />
      <PriceColumn>{formatPrice(intl, price, 2)}</PriceColumn>
    </Row>
  );
};

export default TotalRow;
